import { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { Search } from 'lucide-react'
import { EMOJI_CATEGORIES, getRecentEmojis, pushRecentEmoji, searchEmojis } from './emojiData'

// Emoji seçici — arama + sık kullanılanlar + kategoriler (npm bağımlılığı yok)
// keepOpen: WhatsApp gibi arka arkaya birden fazla emoji seçilebilsin (composer)
export default function EmojiPicker({ x, y, onPick, onClose, keepOpen = false }) {
  const ref = useRef(null)
  const [q, setQ] = useState('')
  const [pos, setPos] = useState({ left: x, top: y })
  const [recent, setRecent] = useState(getRecentEmojis)
  const results = useMemo(() => searchEmojis(q), [q])

  useLayoutEffect(() => {
    const el = ref.current; if (!el) return
    const r = el.getBoundingClientRect()
    let left = x, top = y
    if (left + r.width > window.innerWidth - 8) left = Math.max(8, window.innerWidth - r.width - 8)
    if (top + r.height > window.innerHeight - 8) top = Math.max(8, window.innerHeight - r.height - 8)
    setPos({ left, top })
  }, [x, y])

  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose?.() }
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose?.() } }
    document.addEventListener('mousedown', onDown, true)
    document.addEventListener('keydown', onKey, true)
    return () => { document.removeEventListener('mousedown', onDown, true); document.removeEventListener('keydown', onKey, true) }
  }, [onClose])

  const pick = (e) => {
    pushRecentEmoji(e); onPick?.(e)
    if (keepOpen) setRecent(getRecentEmojis())   // çoklu seçimde sık kullanılanlar canlı güncellensin
    else onClose?.()
  }
  const Grid = ({ items }) => (
    <div className="grid grid-cols-9 gap-0.5">
      {items.map((e, i) => (
        <button key={`${e}${i}`} onClick={() => pick(e)} className="aspect-square rounded hover:bg-gray-100 text-[18px] leading-none flex items-center justify-center">{e}</button>
      ))}
    </div>
  )

  return createPortal(
    <div ref={ref} style={{ left: pos.left, top: pos.top, width: 330 }}
      onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}
      className="fixed z-[85] bg-white rounded-xl shadow-2xl border border-gray-100 p-2.5">
      <div className="relative mb-2">
        <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ara… (ör. onay, ateş, kalp)"
          className="w-full pl-7 pr-2 py-1.5 text-sm border border-gray-200 rounded-lg outline-none focus:ring-1 focus:ring-violet-200" />
      </div>
      <div className="max-h-[300px] overflow-y-auto pr-1">
        {q.trim() ? (
          results.length ? <Grid items={results} /> : <div className="py-6 text-center text-xs text-gray-400">sonuç yok</div>
        ) : (
          <>
            {recent.length > 0 && (
              <div className="mb-2">
                <div className="text-[10px] font-semibold text-gray-400 uppercase mb-1">Sık kullanılanlar</div>
                <Grid items={recent} />
              </div>
            )}
            {EMOJI_CATEGORIES.map((c) => (
              <div key={c.key} className="mb-2">
                <div className="text-[10px] font-semibold text-gray-400 uppercase mb-1">{c.label}</div>
                <Grid items={c.items.map(([e]) => e)} />
              </div>
            ))}
          </>
        )}
      </div>
    </div>,
    document.body,
  )
}
